import { render } from "./FeesView.vue?vue&type=template&id=0575ed71"
import script from "./FeesView.vue?vue&type=script&lang=js"
export * from "./FeesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__